module.exports = __webpack_public_path__ + "static/media/elacma_award.855bc24d.jpeg";